<template>
  <AlertBase :type="props.type" :noIcon="props.noIcon">
    <div class="ml-3 flex-1 md:flex md:justify-between">
      <p class="text-sm" :class="contentClasses">
        <slot />
      </p>
      <p class="mt-3 text-sm md:mt-0 md:ml-6">
        <LinkBase
          :href="props.href"
          class="group whitespace-nowrap"
          :color="getColorFromType(props.type)"
          :external="props.external"
          arrow
          >{{ props.label }}</LinkBase
        >
      </p>
    </div>
  </AlertBase>
</template>

<script setup>
import { computed } from 'vue'

import AlertBase from './AlertBase.vue'
import { getContentClasses } from './common'
import LinkBase from '@/Common/Text/LinkBase.vue'

const props = defineProps({
  type: {
    type: String,
    default: 'info',
  },
  noIcon: Boolean,
  href: String,
  label: String,
  external: Boolean,
})

const contentClasses = computed(() => {
  return getContentClasses(props.type)
})

function getColorFromType(type) {
  return {
    success: 'text-green-700',
    info: 'text-blue-700',
    error: 'text-red-700',
    warning: 'text-yellow-700',
  }[type]
}
</script>
